// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-Header-components-Feedback-Feedback-module__body {
  width: calc(5 * var(--space-6xl));
  height: 100%;
}
.src-shared-components-Header-components-Feedback-Feedback-module__body .src-shared-components-Header-components-Feedback-Feedback-module__formComponent {
  margin-bottom: var(--space-xs);
}
.src-shared-components-Header-components-Feedback-Feedback-module__body .src-shared-components-Header-components-Feedback-Feedback-module__informer {
  margin-bottom: var(--space-xs);
  width: 95%;
}
.src-shared-components-Header-components-Feedback-Feedback-module__body .src-shared-components-Header-components-Feedback-Feedback-module__informText {
  margin-bottom: var(--space-xs);
}

.src-shared-components-Header-components-Feedback-Feedback-module__filesContainer {
  width: 100%;
  max-height: calc(1.5 * var(--space-6xl));
  overflow-y: auto;
  padding-right: var(--space-2xs);
}

.canary--DragNDropField {
  padding: var(--space-2xs) !important;
}

.canary--DragNDropFieldInformer-Text {
  white-space: pre;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Header/components/Feedback/Feedback.module.scss"],"names":[],"mappings":"AAAA;EACC,iCAAA;EACA,YAAA;AACD;AACC;EACC,8BAAA;AACF;AAEC;EACC,8BAAA;EACA,UAAA;AAAF;AAGC;EACC,8BAAA;AADF;;AAKA;EACC,WAAA;EACA,wCAAA;EACA,gBAAA;EACA,+BAAA;AAFD;;AAKA;EACC,oCAAA;AAFD;;AAKA;EACC,gBAAA;AAFD","sourcesContent":[".body {\n\twidth: calc(5*var(--space-6xl));\n\theight: 100%;\n\n\t.formComponent{\n\t\tmargin-bottom: var(--space-xs);\n\t}\n\n\t.informer {\n\t\tmargin-bottom: var(--space-xs);\n\t\twidth: 95%;\n\t}\n\n\t.informText{\n\t\tmargin-bottom: var(--space-xs);\n\t}\n}\n\n.filesContainer {\n\twidth: 100%;\n\tmax-height: calc(1.5*var(--space-6xl));\n\toverflow-y: auto;\n\tpadding-right: var(--space-2xs);\n}\n\n:global(.canary--DragNDropField) {\n\tpadding: var(--space-2xs) !important;\n}\n\n:global(.canary--DragNDropFieldInformer-Text) {\n\twhite-space: pre;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `src-shared-components-Header-components-Feedback-Feedback-module__body`,
	"formComponent": `src-shared-components-Header-components-Feedback-Feedback-module__formComponent`,
	"informer": `src-shared-components-Header-components-Feedback-Feedback-module__informer`,
	"informText": `src-shared-components-Header-components-Feedback-Feedback-module__informText`,
	"filesContainer": `src-shared-components-Header-components-Feedback-Feedback-module__filesContainer`
};
export default ___CSS_LOADER_EXPORT___;
